export enum EnvironmentOptions {
  Development = 'DEVELOPMENT',
  Production = 'PRODUCTION',
}

export enum ScheduleOptions {
  Single = 'SINGLE',
  Recurrence = 'RECURRENCE',
}

export enum RoleOptions {
  instructor = 'instructor',
  administrator = 'administrator',
  customer = 'customer'
}